<template>
  <div>
    <div v-for="education in educations" :key="education.id" class="faded_border_bottom" style="padding-top: 10px;">
      <p><b>Education Institution: </b>{{education.education_institution.name}}</p>
      <p v-if="education.education_degree != undefined"><b>Education Degree: </b>{{education.education_degree.name}}</p>
      <p v-if="education.education_course != undefined"><b>Education Course: </b>{{education.education_course.name}}</p>
      <p v-if="education.grade"><b>Grade: </b>{{education.grade}}</p>
      <p v-if="education.with_honors"><b>With Honors: </b>{{education.with_honors}}</p>
    </div>
    <p v-if="educations.length == 0">EDUCATIONS IS EMPTY</p>
  </div>
</template>
<script>
export default {
  name: 'position-educations',
  props: ['payload'],
  data () {
    return {
      educations: []
    }
  },
  created () {
    this.$network_utils.getPositionEducations({
      current_company_id: this.payload.company_id,
      position_id: this.payload.position_id
    }).then(response => {
      this.educations = response
    })
  }
}
</script>
